/** @file useTilePaste: Ctrl+V of an image onto the Tile screen replaces the canvas (the page's paste event). */
import { useEffect } from 'react';
import { tileTakeImage } from './tileTakeImage';

/**
 * Listens to `paste` on the window while mounted (a key binding on Ctrl+V would cancel the browser's paste); the
 * first image file of the clipboard goes through `tileTakeImage`; text pastes into fields are left alone.
 */
export function useTilePaste(draftKey: string, size: readonly [number, number], onError: (message: string) => void): void {
  const [w, h] = size;
  useEffect(() => {
    const paste = (e: ClipboardEvent): void => {
      const file = [...(e.clipboardData?.files ?? [])].find((f) => f.type.startsWith('image/'));
      if (file === undefined) return;
      e.preventDefault();
      void tileTakeImage(draftKey, [w, h], file).then((error) => { if (error !== null) onError(error); });
    };
    window.addEventListener('paste', paste);
    return () => { window.removeEventListener('paste', paste); };
  }, [draftKey, w, h, onError]);
}
